import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";

import App from './App';
import './pages/global.css';

Sentry.init({

    dsn: "https://3763b4ffffc1910fcc1494baeab190a8@o4509604970168320.ingest.us.sentry.io/4509604973445120",


    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
        }),
    ],

    tracesSampleRate: 1.0,

    replaysOnErrorSampleRate: 1.0,

    replaysSessionSampleRate: 0.1,

    sendDefaultPii: true
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
